/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRapportGridDto } from './FcbRapportGridDto';
import {
    FcbRapportGridDtoFromJSON,
    FcbRapportGridDtoFromJSONTyped,
    FcbRapportGridDtoToJSON,
} from './FcbRapportGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRapportGridDtoPaginatedResults
 */
export interface FcbRapportGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRapportGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRapportGridDto>}
     * @memberof FcbRapportGridDtoPaginatedResults
     */
    results?: Array<FcbRapportGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRapportGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRapportGridDtoPaginatedResults interface.
 */
export function instanceOfFcbRapportGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRapportGridDtoPaginatedResultsFromJSON(json: any): FcbRapportGridDtoPaginatedResults {
    return FcbRapportGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRapportGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRapportGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRapportGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRapportGridDtoPaginatedResultsToJSON(value?: FcbRapportGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRapportGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

